export default __webpack_public_path__ + "static/media/1887.c2ab0898.png";